import {
  AfterViewInit,
  Directive,
  ElementRef,
  EventEmitter,
  OnDestroy,
  Output,
} from "@angular/core";

/**
 * Directive to work around Ionic ion-searchbar bug where the search icon
 * click does not trigger the (search) event.
 *
 * Ionic Framework Issue References:
 * - https://github.com/ionic-team/ionic-framework/issues/19997
 * - https://github.com/ionic-team/ionic-framework/issues/26828
 * - https://forum.ionicframework.com/t/ionic-search-bar-search-icon-clicked/77072/3
 *
 * Usage:
 * <ion-searchbar
 *   searchIconClickable
 *   (searchIconClick)="onSearch()"
 *   (keyup.enter)="onSearch()"
 * ></ion-searchbar>
 */
@Directive({
  selector: "[searchIconClickable]",
})
export class SearchbarIconClickDirective implements AfterViewInit, OnDestroy {
  @Output() searchIconClick = new EventEmitter<void>();

  private clickHandler: (() => void) | null = null;
  private searchIcon: Element | null = null;

  constructor(private elementRef: ElementRef) {}

  ngAfterViewInit(): void {
    this.searchIcon = this.elementRef.nativeElement.querySelector(
      ".searchbar-search-icon"
    );

    if (this.searchIcon) {
      this.clickHandler = () => this.searchIconClick.emit();
      this.searchIcon.addEventListener("click", this.clickHandler);
    }
  }

  ngOnDestroy(): void {
    if (this.searchIcon && this.clickHandler) {
      this.searchIcon.removeEventListener("click", this.clickHandler);
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/common/searchbar/searchbar-icon-click.directive.ts